import { api } from '@shared/config/axios';

export default {
  incrementVisit(data) {
    return api.$put('/affiliations/visits', data);
  },
};
